const BASE_URL = (window.webpackHotUpdate !== undefined) ? "https://localhost:5001/" : "https://api.giustup.it/";
const BASE_URL_FRONTEND = (window.webpackHotUpdate !== undefined) ? "http://localhost:8080/" : "https://giustup.it/";

export default {
  getBaseUrl() {
    return BASE_URL
  },
  getBaseUrlFrontend() {
    return BASE_URL_FRONTEND
  }
}



// WEBPACK FOOTER //
// ./src/services/baseUrl.js